/**
 * NOWROCKY™ — Paid Add-ons Checkboxes Logic (PDP)
 * 
 * - Oblicza sumę całkowitą (cena produktu + dodatki) w locie i aktualizuje przycisk "Dodaj do koszyka".
 * - Wyświetla łączną kwotę z dodatkami PRZED napisem "ADD TO CART" / "DODAJ DO KOSZYKA".
 * - Obsługuje dynamiczne pola na tekst/komentarz klienta (max 250 znaków) z licznikiem i walidacją.
 * - Bezpieczna synchronizacja właściwości (line item properties) bezpośrednio w formularzu.
 */
(function () {
  'use strict';

  function formatMoney(cents, currencyFormat) {
    if (typeof cents !== 'number' || isNaN(cents)) cents = 0;
    var isNegative = cents < 0;
    var absCents = Math.abs(cents);
    var dollars = absCents / 100;
    
    var hasComma = currencyFormat && (
      currencyFormat.indexOf('amount_with_comma_separator') !== -1 ||
      currencyFormat.indexOf('amount_no_decimals_with_comma_separator') !== -1 ||
      currencyFormat.indexOf('zł') !== -1 ||
      currencyFormat.indexOf('PLN') !== -1
    );

    var formattedNumber = hasComma
      ? dollars.toFixed(2).replace('.', ',')
      : dollars.toFixed(2);

    var result = '';
    if (currencyFormat) {
      if (currencyFormat.indexOf('{{amount_with_comma_separator}}') !== -1) {
        result = currencyFormat.replace('{{amount_with_comma_separator}}', formattedNumber);
      } else if (currencyFormat.indexOf('{{amount_no_decimals_with_comma_separator}}') !== -1) {
        result = currencyFormat.replace('{{amount_no_decimals_with_comma_separator}}', String(Math.round(dollars)));
      } else if (currencyFormat.indexOf('{{amount_no_decimals}}') !== -1) {
        result = currencyFormat.replace('{{amount_no_decimals}}', String(Math.round(dollars)));
      } else if (currencyFormat.indexOf('{{amount}}') !== -1) {
        result = currencyFormat.replace('{{amount}}', formattedNumber);
      } else {
        result = '$' + formattedNumber;
      }
    } else {
      result = '$' + formattedNumber;
    }

    if (isNegative) {
      return '-' + result;
    }
    return result;
  }

  /**
   * Finds the actual ATC button on the PDP. We scope tightly to avoid
   * accidentally injecting the badge into payment-icon wrappers, dynamic
   * checkout buttons, or anything in the footer / other sections.
   */
  function findATCButton() {
    // Primary: the submit button inside the product-form component
    var productFormComponent = document.querySelector('product-form-component, product-form');
    if (productFormComponent) {
      var btn = productFormComponent.querySelector('button[name="add"], button.add-to-cart-button');
      if (btn) return [btn];
    }
    // Fallback: button with name="add" that is inside a form with /cart/add action
    var forms = document.querySelectorAll('form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
    var results = [];
    for (var f = 0; f < forms.length; f++) {
      var btn = forms[f].querySelector('button[name="add"], button.add-to-cart-button');
      if (btn) results.push(btn);
    }
    return results;
  }

  function initAddonsContainer(container) {
    if (!container) return;

    var basePriceCents = parseInt(container.dataset.basePriceCents, 10) || 0;
    var currencyFormat = container.dataset.currencyFormat || '${{amount}}';
    var summaryEl = container.querySelector('[data-nwr-addons-summary-total]');

    function getLiveBasePriceCents() {
      var datasetBase = parseInt(container.dataset.basePriceCents, 10);
      if (datasetBase && datasetBase > 500) return datasetBase;

      try {
        if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
          var prod = window.ShopifyAnalytics.meta.product;
          var selId = window.ShopifyAnalytics.meta.selectedVariantId;
          if (prod.variants && prod.variants.length) {
            if (selId) {
              for (var v = 0; v < prod.variants.length; v++) {
                if (prod.variants[v].id === selId) return prod.variants[v].price;
              }
            }
            return prod.variants[0].price;
          }
        }
      } catch (e) {}

      var priceEl = document.querySelector('.price-item--regular, .price-item--sale, .product-price');
      if (priceEl) {
        var rawText = priceEl.textContent || '';
        var num = rawText.replace(/[^0-9.,]/g, '').replace(',', '.');
        var parsed = parseFloat(num);
        if (!isNaN(parsed) && parsed > 0) {
          return Math.round(parsed * 100);
        }
      }

      return datasetBase || basePriceCents || 0;
    }

    function getSelectedAddons() {
      var itemsEls = container.querySelectorAll('[data-nwr-addon]');
      var totalCents = 0;
      var items = [];

      for (var i = 0; i < itemsEls.length; i++) {
        var itemEl = itemsEls[i];
        var input = itemEl.querySelector('[data-nwr-addon-input]');
        if (!input || !input.checked) continue;

        var price = parseInt(input.dataset.priceCents, 10) || 0;
        totalCents += price;

        var name = input.dataset.addonName || input.name.replace(/^properties\[/, '').replace(/\]$/, '');
        var priceFormatted = input.dataset.addonPriceFormatted;
        if (!priceFormatted) {
          if (price < 0) {
            priceFormatted = '-' + formatMoney(Math.abs(price), currencyFormat);
          } else if (price > 0) {
            priceFormatted = '+' + formatMoney(price, currencyFormat);
          } else {
            priceFormatted = formatMoney(0, currencyFormat);
          }
        }
        var variantId = input.dataset.variantId || '';

        var textarea = itemEl.querySelector('[data-nwr-addon-textarea]');
        var customText = (textarea && textarea.value) ? textarea.value.trim() : '';
        var propNameText = textarea ? (textarea.dataset.propName || (name + ' - Tekst')) : '';

        items.push({
          name: name,
          priceCents: price,
          priceFormatted: priceFormatted,
          variantId: variantId,
          customText: customText,
          propNameText: propNameText
        });
      }

      return { totalCents: totalCents, items: items };
    }

    // syncFormProperties completely removed to prevent parent product properties
    
    function updateATCButtons(addons) {
      var atcButtons = findATCButton();
      var updateButtonPrice = container.dataset.updateButtonPrice !== 'false';

      for (var i = 0; i < atcButtons.length; i++) {
        var btn = atcButtons[i];
        var badge = btn.querySelector('.nwr-atc-addon-badge');

        if (addons.items.length > 0 && updateButtonPrice) {
          var currentBase = getLiveBasePriceCents();
          var totalCents = Math.max(0, currentBase + addons.totalCents);
          var formattedTotal = formatMoney(totalCents, currencyFormat);

          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'nwr-atc-addon-badge';
            // Insert BEFORE the text content of the button, after the icon
            var icon = btn.querySelector('.add-to-cart-icon, .svg-wrapper');
            if (icon && icon.parentNode === btn) {
              icon.insertAdjacentElement('afterend', badge);
            } else if (btn.firstChild) {
              btn.insertBefore(badge, btn.firstChild);
            } else {
              btn.appendChild(badge);
            }
          }
          badge.textContent = formattedTotal;
          badge.style.display = 'inline-flex';

          // Taniej -> zielony (is-cheaper / is-discount), Drożej -> czerwony (is-expensive / is-increase)
          badge.classList.remove('is-cheaper', 'is-discount', 'is-expensive', 'is-increase');
          if (addons.totalCents < 0) {
            badge.classList.add('is-cheaper', 'is-discount');
          } else if (addons.totalCents > 0) {
            badge.classList.add('is-expensive', 'is-increase');
          }

          btn.setAttribute('data-addons-total-cents', String(addons.totalCents));
          btn.setAttribute('data-total-with-addons-cents', String(totalCents));
        } else {
          if (badge) badge.remove();
          btn.removeAttribute('data-addons-total-cents');
          btn.removeAttribute('data-total-with-addons-cents');
        }
      }
    }

    function updateDisplay() {
      var itemsEls = container.querySelectorAll('[data-nwr-addon]');
      for (var i = 0; i < itemsEls.length; i++) {
        var itemEl = itemsEls[i];
        var input = itemEl.querySelector('[data-nwr-addon-input]');
        var textWrap = itemEl.querySelector('[data-nwr-addon-text-wrap]');
        var textarea = itemEl.querySelector('[data-nwr-addon-textarea]');

        if (input && input.checked) {
          itemEl.classList.add('is-selected');
          if (textWrap) {
            textWrap.style.display = 'block';
            if (textarea) textarea.removeAttribute('disabled');
          }
        } else {
          itemEl.classList.remove('is-selected');
          if (textWrap) {
            textWrap.style.display = 'none';
            if (textarea) {
              textarea.setAttribute('disabled', 'disabled');
              textarea.classList.remove('is-invalid');
            }
          }
        }
      }

      var selected = getSelectedAddons();
      if (summaryEl) {
        var summaryWrap = container.querySelector('[data-nwr-addons-summary]');
        if (selected.items.length > 0 && selected.totalCents !== 0) {
          if (selected.totalCents > 0) {
            summaryEl.textContent = '+' + formatMoney(selected.totalCents, currencyFormat);
            summaryEl.classList.remove('is-discount');
            summaryEl.classList.add('is-increase');
          } else {
            summaryEl.textContent = '-' + formatMoney(Math.abs(selected.totalCents), currencyFormat);
            summaryEl.classList.remove('is-increase');
            summaryEl.classList.add('is-discount');
          }
          if (summaryWrap) summaryWrap.style.display = 'flex';
        } else if (selected.items.length > 0 && selected.totalCents === 0) {
          summaryEl.textContent = formatMoney(0, currencyFormat);
          summaryEl.classList.remove('is-discount', 'is-increase');
          if (summaryWrap) summaryWrap.style.display = 'flex';
        } else {
          if (summaryWrap) summaryWrap.style.display = 'none';
        }
      }

      updateATCButtons(selected);
    }

    // Nasłuchiwanie zmian na checkboxach (native label handles clicks everywhere on the row)
    container.addEventListener('change', function (e) {
      if (e.target && e.target.matches('[data-nwr-addon-input]')) {
        updateDisplay();
      }
    });

    // Obsługa licznika znaków (0/250) oraz wpisywania tekstu
    container.addEventListener('input', function (e) {
      if (e.target && e.target.matches('[data-nwr-addon-textarea]')) {
        var textarea = e.target;
        var box = textarea.closest('[data-nwr-addon-text-wrap]');
        if (box) {
          var counter = box.querySelector('[data-nwr-char-count]');
          if (counter) {
            counter.textContent = String(textarea.value.length);
          }
        }
        if (textarea.value.trim().length > 0) {
          textarea.classList.remove('is-invalid');
        }
      }
    });

    // Walidacja wymaganych pól tekstowych przed submitowaniem
    function validateAddonTexts() {
      var itemsEls = container.querySelectorAll('[data-nwr-addon]');
      var hasError = false;

      for (var i = 0; i < itemsEls.length; i++) {
        var itemEl = itemsEls[i];
        var input = itemEl.querySelector('[data-nwr-addon-input]');
        var textarea = itemEl.querySelector('[data-nwr-addon-textarea]');

        if (input && input.checked && textarea && textarea.dataset.required === 'true') {
          if (!textarea.value || textarea.value.trim().length === 0) {
            hasError = true;
            textarea.classList.add('is-invalid');
            textarea.focus();
            break;
          }
        }
      }

      return !hasError;
    }

    // Nasłuchiwanie zmiany wariantu (zachowanie checkboxów, aktualizacja ceny bazowej)
    function onVariantChange(event) {
      try {
        if (event && event.detail) {
          var variantObj = event.detail.variant || (event.detail.resource && event.detail.resource);
          if (variantObj && typeof variantObj.price === 'number') {
            basePriceCents = variantObj.price;
            container.dataset.basePriceCents = String(basePriceCents);
            updateDisplay();
            return;
          }
        }
        if (event && event.promise) {
          event.promise.then(function (res) {
            if (res && res.detail && res.detail.resource && typeof res.detail.resource.price === 'number') {
              basePriceCents = res.detail.resource.price;
              container.dataset.basePriceCents = String(basePriceCents);
              updateDisplay();
            }
          }).catch(function () {});
        }
      } catch (err) {}
    }

    document.addEventListener('shopify:events:product-select', onVariantChange);
    document.addEventListener('variant:change', onVariantChange);

    // Pierwsza inicjalizacja
    updateDisplay();

    // Re-initialize on back/forward navigation (bfcache)
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        updateDisplay();
      }
    });
  }

  function boot() {
    var containers = document.querySelectorAll('[data-nwr-addons]');
    for (var i = 0; i < containers.length; i++) {
      initAddonsContainer(containers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

  window.NWR_PRODUCT_ADDONS = {
    boot: boot,
    init: initAddonsContainer
  };
})();
